import {useEffect, useRef, useState} from 'react';

import {
  getUserLLMAgentGuidelines,
  setUserLLMAgentGuidelines,
} from 'llm/chat-library/agent-guidelines/AgentGuidelinesDAO';

interface UseUserAgentGuidelinesResult {
  guidelines: string | null;
  isLoading: boolean;
  setGuidelines: (value: string) => void;
  saveGuidelines: (newValue: string) => Promise<void>;
}

/**
 * Hook to manage user LLM agent guidelines.
 */
export default function useUserAgentGuidelines(): UseUserAgentGuidelinesResult {
  const [guidelines, setGuidelines] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const isMountedRef = useRef(true);

  useEffect(() => {
    isMountedRef.current = true;

    async function loadGuidelines(): Promise<void> {
      const existingGuidelines = await getUserLLMAgentGuidelines();
      if (isMountedRef.current) {
        setGuidelines(existingGuidelines || '');
        setIsLoading(false);
      }
    }

    loadGuidelines();

    return () => {
      isMountedRef.current = false;
    };
  }, []);

  async function saveGuidelines(newValue: string): Promise<void> {
    await setUserLLMAgentGuidelines(newValue);
    if (isMountedRef.current) {
      setGuidelines(newValue);
    }
  }

  return {
    guidelines,
    isLoading,
    setGuidelines,
    saveGuidelines,
  };
}
